/*
 * @Author: Jing
 * @Date: 2021-12-24 14:38:13
 * @Descripttion: 
 */
import type { App } from 'vue';
import { setupQrCodeDirective } from './modules/qrCode';
import { setupBarCodeDirective } from './modules/barCode';

export function setupGlobDirectives(app: App) {
    setupQrCodeDirective(app);
    setupBarCodeDirective(app);
}
